module.exports = __webpack_public_path__ + "img/client-4.c77e6256.png";